import {enums} from "../enums.js";
import {useEffect, useState} from "react";
import './css/DictionaryPage.css'
import {FormattedMessage} from "react-intl";


export const DictionaryPage = (props) => {
    useEffect(() => {
        props.onEnter();
    }, []);

    const [selected, setEnum] = useState('')

    const withoutTranslate = ['RoleEnum', 'LanguageLvEnum', 'FieldTypeEnum']

    const enumContainer = [];
    for (const property in enums) {
        enumContainer.push(
            <div key={property}>
                <h2 onClick={() => {
                    if (selected === property) {
                        setEnum('')
                    } else {
                        setEnum(property)
                    }
                }}>{property}</h2>
                {selected === property && <div className="enum-values">
                    {enums[property].map((option, i) => (
                        <div key={i}>{option} {!withoutTranslate.includes(property) &&
                            <span>- <FormattedMessage id={option}></FormattedMessage></span>}</div>
                    ))}
                </div>}
                <hr/>
            </div>
        );
    }
    return <div className="main-container">
        <div className="fields-container">
            {enumContainer}
        </div>
    </div>;

}